import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'Autoinjector - Standard' },
    { value: 2, label: 'Autoinjector - Junior' },
    { value: 3, label: 'Asthma Inhaler - General use' },
    { value: 4, label: 'General Use - Unprescribed' },
    { value: 5, label: 'Prescribed Medication' },
  ],
});
